import { render, staticRenderFns } from "./ShapleyValuesVariableImportance.vue?vue&type=template&id=8c72bc5a&"
import script from "./ShapleyValuesVariableImportance.vue?vue&type=script&lang=js&"
export * from "./ShapleyValuesVariableImportance.vue?vue&type=script&lang=js&"
import style0 from "./ShapleyValuesVariableImportance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports